import { module } from 'modujs';
import axios from 'axios';

export default class extends module {
    constructor(m) {
        super(m);

        this.postContainer = this.el.querySelector('[data-post-container]');
        this.loadMorebtn = this.el.querySelector('[data-load-more="load-more"]');
        this.btn = this.el.querySelector('[data-load-more="btn"]');
        this.pagination = this.el.querySelector('[data-load-more="pagination"]');

        this.bindEvents();
    }

    bindEvents() {
        if (this.loadMorebtn) {
            this.loadMorebtn.addEventListener('click', this.handleLoadMore.bind(this));
        }

        if (this.pagination) {
            this.bindPaginationLinks();
        }
    }

    bindPaginationLinks() {
        const links = this.pagination.querySelectorAll('a');

        links.forEach((link) => {
            link.addEventListener('click', this.handlePaginationClick.bind(this));
        });
    }

    handleLoadMore() {
        const page = parseInt(this.loadMorebtn.dataset.page, 10);
        const postType = this.loadMorebtn.dataset.posttype;
        const howmany = this.loadMorebtn.dataset.howmany;

        this.loadMorebtn.textContent = 'Loading...';

        const params = new URLSearchParams();
        params.append('action', 'load_more_posts');
        params.append('paged', page);
        params.append('posttype', postType);
        params.append('howmany', howmany);

        axios.post(theme_ajax.ajax_url, params)
            .then((res) => {
                const data = res.data;

                if (data.html.trim() !== '' && this.postContainer) {
                    this.postContainer.insertAdjacentHTML('beforeend', data.html);
                    this.loadMorebtn.dataset.page = page + 1;
                    this.loadMorebtn.textContent = 'Explore More';

                    const currentPosts = this.postContainer.querySelectorAll('[data-post-id]').length;

                    if (currentPosts >= data.total && this.btn) {
                        this.btn.remove();
                    }
                } else if (this.btn) {
                    this.btn.remove();
                }
            })
            .catch((err) => {
                console.error('AJAX Error:', err);
                this.loadMorebtn.textContent = 'Error';
            });
    }

    handlePaginationClick(e) {
        e.preventDefault();

        const link = e.currentTarget;
        const url = new URL(link.href);
        const pageMatch = url.pathname.match(/\/page\/(\d+)\/?$/);
        const pageFromPath = pageMatch ? pageMatch[1] : null;
        const pageFromQuery = url.searchParams.get('paged');
        const page = parseInt(pageFromQuery || pageFromPath || 1, 10);

        const postType = this.pagination.dataset.posttype;
        const howmany = this.pagination.dataset.howmany;
        const currentUrl = this.postContainer.dataset.target;

        if (!this.postContainer) {
            return;
        }

        const params = new URLSearchParams();
        params.append('action', 'paginate_posts');
        params.append('paged', page);
        params.append('posttype', postType);
        params.append('howmany', howmany);
        params.append('current_url', currentUrl);

        axios.post(theme_ajax.ajax_url, params)
            .then((res) => {
                const data = res.data;

                if (data.html !== undefined) {
                    this.postContainer.innerHTML = data.html;
                }

                if (data.pagination !== undefined && this.pagination) {
                    this.pagination.innerHTML = data.pagination;
                    this.bindPaginationLinks();
                }

                window.history.pushState({}, '', link.href);

                this.el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            })
            .catch((err) => {
                console.error('AJAX Pagination Error:', err);
            });
    }
}